import script from "./chart4.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart4.vue?vue&type=script&lang=ts&setup=true"

import "./chart4.vue?vue&type=style&index=0&id=5f0f5bb2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0f5bb2"]])

export default __exports__